import { IAbstractModel } from "model/abstract.model";
import { IConsumidor } from "model/cliente.model";
import { ICpfNota } from "pages/cpfNota/CpfNota";
import { TDadosTransportador } from "pages/DadosTransportador";
import { UltimaNotaPorSkuDTO } from "pages/nota-referenciada/NotaReferenciada.service";
import { DadosCartaoTO, IDadosCheque, IPagamentoRow } from "pages/pagamento/pagamento.model";
import { FlowVendedorDTO } from "./OutrosComissionados";

export interface FlowVendaTO {
    uuid: string,
    valorTotalBruto: number,
    valorTotalLiquido: number,
    valorTotalLiquidoTroca: number,
    quantidadeTotal: number,
    quantidadeTotalTroca: number;
    emissao: Date | string,
    entrega: Date | string,
    numero: string,
    numeroEntrega: number,
    statusPedido: StatusPedido,
    cliente: IConsumidor | null,
    vendedorPrincipal: FlowVendedorDTO | null,
    outrosVendedores: FlowVendedorDTO[],
    guias: FlowVendedorDTO[],
    formaComissao: IAbstractModel | null,
    finalidadePedido: IAbstractModel | null;
    parcelas: Array<IAbstractModel>,
    condicoesPagamento: Array<IAbstractModel>,
    itensPagamento: Array<IPagamentoRow>;
    itensPagamentoDevolucao: Array<IPagamentoRow>;
    itens: Array<IProdutoRow>;
    itensTroca: Array<ITrocaRow>;
    cpfNota: ICpfNota | null;
    pedidoDescontoAcrescimo: PedidoItemDesconto;
    flowItensTroca: Array<TFlowProdutoImpressaoTO>

    // novosParams
    estabelecimento: {
        nomeFantasia: string;
        telefone: string;
        endereco: string;
        inscricaoEstadual: string;
        complemento: string;
        municipio: string;
        email: string;
        cep: string;
    };
    flowItens: {
        produtos: Array<TFlowProdutoImpressaoTO>;
        condicaoPagamentos: Array<string>;
        dadosChequeTOS: Array<IDadosCheque>,
        dadosCartaoTOS: Array<DadosCartaoTO>;

    };
    transportador: TDadosTransportador;
    parcelasCrediario: Array<DadosPagamentoParcelaTO>;
    observacao: string;
    observacaoFixa: string;
    // Especificos Flow
    consultados: string[];
    tabelaPreco: IAbstractModel | null;
    deposito: IAbstractModel | null;
    troco: FlowTrocoTO | null;
    canalDeVenda: IAbstractModel | null
    pedidosAgrupados: string[];
}

export type DadosPagamentoParcelaTO = {
    formaPagamento: IAbstractModel,
    numeroParcela: number;
    numeroDias: number;
    vencimento: Date;
    valor: number;
};

export type TFlowTamanhoImpressaoTO = {
    tamanho: string,
    quantidade: number;
};

export type TFlowCorImpressaoTO = {
    cor: string,
    valorUnitario: string,
    desconto: string,
    valorTotal: number,
    quantidade: number,
    tamanhos: Array<TFlowTamanhoImpressaoTO>;
};

export type TFlowProdutoImpressaoTO = {
    nome: string,
    cores: Array<TFlowCorImpressaoTO>;
    tamanhos: Array<TFlowTamanhoImpressaoTO>;
};

export type PedidoItemDesconto = {
    uuidAutorizador: string | null;
    valorDesconto: number;
    percentualDesconto: number;
    tipoDesconto: TipoDesconto;
    acrescimo: number;
};

export interface IProdutoRow {
    produto: IProduto;
    estoque: number,
    quantidade: number;
    valorTotal: number;
    itemDesconto: Omit<PedidoItemDesconto, 'acrescimo'>;
    brinde?: boolean;
    isTroca: boolean;
    uuid: string;
}

export type FichaImagemDetalheDTO = {
    url: string;
    cor: string;
    infoAdicional: string;
}

export interface IProduto {
    uuid: string,
    codigoSku: string;
    nome: string;
    cor: string;
    tamanho: string;
    preco: number,
    tipo: TipoItem;
    descritivo: string;
    uuidProduto: string;
}

export interface CupomTrocaSkuDTO {
    uuid: string;
    codigo: string;
    produto: IProduto;
    notaFiscalVenda: {
        chaveAcesso: string;
        serie: string;
        numeroNota: string;
    };
}

export enum TipoDesconto {
    PERCENTUAL = 'PERCENTUAL',
    VALOR = 'VALOR'
}

export enum StatusPedido {
    ABERTO = 'ABERTO',
    FATURADO = 'FATURADO',
    CANCELADO = 'CANCELADO',
}

export enum TipoItem {
    PRINCIPAL = 'PRINCIPAL',
    LOJA = 'LOJA',
    OUTROS = 'OUTROS',
    SKU = 'SKU'
}

export interface IPedidoFooter {
    quantidade: number,
    valorTotal: number,
    desconto: number,
    tipoDesconto: TipoDesconto,
    valorTotalLiquido: number;
}

export type TPagamentoReceivedProps = {
    receivedParams: boolean;
    isVisualizar: boolean;
};

export type EstoqueTO = {
    sku: IAbstractModel;
    deposito: IAbstractModel;
    saldo: string;
    reserva: string;
};

export const headerWidths = {
    produtoVenda: 48,
    // estoque: 10,
    quantidade: 10,
    valorUnitario: 10,
    desconto: 10,
    total: 7,
    brinde: 10,
    lixeira: 5
};
export type FlowCreatePedidoCieloTOResponse = {
    uuidOrigem: string;
    reference: string;
    credenciadoraUUID: string;
};

export enum TipoTrocoPagar {
    DINHEIRO = "DINHEIRO",
    NOTA_DE_CREDITO = "NOTA_DE_CREDITO"
}

export type FlowTrocoTO = {
    valor: number,
    tipoTrocoPagar: TipoTrocoPagar;
};

export type FlowConsultaCartaoPagoTO = {
    itensPagamentoTOS: Array<IPagamentoRow>,
    troco: FlowTrocoTO;
};

export type ITrocaRow = IProdutoRow & {
    notaReferenciadaInfo?: {
        notas: UltimaNotaPorSkuDTO[];
        quantidadeNaoReferenciada: number;
    };
    cupomTroca?: {
        uuid: string;
        codigo: string;
    };
};
